import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Spinner,
  Tooltip,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactElement, useRef } from "react";

interface IDialog {
  children: ReactElement;
  description: string | ReactElement;
  question: string;
  isLoading?: boolean;
  onClick: any;
  withTooltip?: boolean;
  tooltipText?: string;
  full?: boolean;
  noText?: string;
  yesText?: string;
}

export default function Dialog({
  children,
  question,
  description,
  onClick,
  isLoading,
  withTooltip = false,
  tooltipText,
  full = false,
  noText = "Cancel",
  yesText = "Confirm",
}: IDialog) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<any>();
  const sizes = useBreakpointValue({ base: "sm", "2xl": "md" });
  const sizesBp = useBreakpointValue({ base: "xs", md: "lg" });

  const onConfirm = async (e: any) => {
    e.stopPropagation();
    await onClick();
    onClose();
  };

  return (
    <>
      {withTooltip ? (
        <Tooltip label={tooltipText} hasArrow>
          <Button
            onClick={onOpen}
            size={full ? "unset" : sizes}
            p="0"
            m="0"
            as="span"
            h="fit-content"
            w={full ? "full" : "fit-content"}
            bg="transparent"
            _hover={{}}
            _active={{}}
            cursor="pointer"
          >
            {children}
          </Button>
        </Tooltip>
      ) : (
        <Button
          onClick={onOpen}
          size={full ? "unset" : sizes}
          p="0"
          m="0"
          as="span"
          h="fit-content"
          w={full ? "full" : "fit-content"}
          bg="transparent"
          _hover={{}}
          _active={{}}
          cursor="pointer"
        >
          {children}
        </Button>
      )}

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isOpen}
        isCentered
        size={sizesBp}
      >
        <AlertDialogOverlay />

        <AlertDialogContent bg={"blackLight"} color="yellowDark" rounded="1rem">
          <AlertDialogHeader>{question}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>{description}</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={onClose}
              disabled={isLoading}
              color="white"
              variant={"link"}
            >
              {noText}
            </Button>
            <Button
              colorScheme="red"
              ml={3}
              disabled={isLoading}
              onClick={onConfirm}
              variant={"link"}

            >
              {isLoading ? <Spinner size={"md"} color="white" /> : yesText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
